import { render, staticRenderFns } from "./poslovni-partneri.editor.vue?vue&type=template&id=71fef798&scoped=true&"
import script from "./poslovni-partneri.editor.vue?vue&type=script&lang=ts&"
export * from "./poslovni-partneri.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fef798",
  null
  
)

export default component.exports